<ng-container
  *ngIf="(serviceConnected$ | async) === true; then serviceConnectedView; else serviceDisconnectedView"
></ng-container>

<ng-template #serviceConnectedView>
  <ng-container *ngIf="useAlternateStyling; then alternateConnectView; else defaultConnectView"></ng-container>
</ng-template>

<ng-template #serviceDisconnectedView>
  <ng-container *ngIf="useAlternateStyling; then alternateDisconnectView; else defaultDisconnectView"></ng-container>
</ng-template>

<ng-template #alternateDisconnectView>
  <ng-content select="integrations-disconnect-element"></ng-content>
</ng-template>

<ng-template #defaultDisconnectView>
  <va-badge color="red">
    {{ 'FRONTEND.MEETING_INTEGRATIONS.CONNECTION_STATUS_ELEMENT.SERVICE_NOT_CONNECTED' | translate }}
  </va-badge>
</ng-template>

<ng-template #alternateConnectView>
  <ng-content select="integrations-connect-element"></ng-content>
</ng-template>

<ng-template #defaultConnectView>
  <va-badge color="green">
    {{ 'FRONTEND.MEETING_INTEGRATIONS.CONNECTION_STATUS_ELEMENT.SERVICE_CONNECTED' | translate }}
  </va-badge>
</ng-template>
